import { Component, OnInit } from "@angular/core";
import { PartnerService } from "src/app/share/service/partner.service";
import { TranslateService } from "@ngx-translate/core";
import { PartnerInfoInterface } from "src/app/share/interface/partner.interface";
import { PARTNER_INFO } from "src/app/share/constants/partner.info";
import { COMMON_INFO } from "src/app/share/constants/common.info";
import { FooterMarginService } from "src/app/share/service/footer-margin.service";
import {
  FooterList,
  FooterService,
  ImageData,
  SocialMediaList
} from "src/app/share/service/footer.service";
import { PartnerDataService } from "src/app/share/service/partnerData.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
  readonly _commonInfo = COMMON_INFO;
  readonly _partnerInfo = PARTNER_INFO;
  partnerInfo: PartnerInfoInterface;
  isCustomFooter: Boolean = false;
  partnerCode: string;
  stepperIndex: number;
  component: string;

  pathName: string = window.location.pathname;

  footerList: FooterList[] = [];
  socialMediaList: SocialMediaList[] = [];
  paymentList: ImageData[] = [];
  bankList: ImageData[] = [];

  constructor(
    public partnerDataService: PartnerDataService,
    private partnerService: PartnerService,
    public translate: TranslateService,
    private footerMarginService: FooterMarginService,
    private footerService: FooterService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.initPartner();

    const [footerList, socialMediaList, payment] = await Promise.all([
      this.footerService.getFooterList(),
      this.footerService.getSocialMediaList({ partnerCode: this.partnerCode }),
      this.footerService.getPaymentList()
    ]);

    this.footerList = footerList;
    this.socialMediaList = socialMediaList;
    this.paymentList = payment.paymentList;
    this.bankList = payment.bankList;

    this.initPaymentFooter();

    this.footerMarginService.stepperIndex$.subscribe((index) => {
      this.stepperIndex = index;
    });
    this.footerMarginService.component$.subscribe((component) => {
      this.component = component;
    });
  }

  async initPartner(): Promise<void> {
    this.partnerCode = (await this.partnerService.getPartnerCode()) || "ps";

    //If the partner requires a custom footer information to be displayed
    if (this._partnerInfo[this.partnerCode] !== undefined) {
      this.isCustomFooter = true;
      this.partnerInfo = this._partnerInfo[this.partnerCode];
    }
  }

  private initPaymentFooter(): void {
    let paymentRemoveList: string[] = [];
    let bankRemoveList: string[] = [];

    switch (this.partnerCode) {
      case "ktmb":
        paymentRemoveList = ["atome", "prolindung", "kits"];
        bankRemoveList = ["hsbc", "stdchartered"];
        break;

      case "prolindung":
        this.paymentList.push();
        paymentRemoveList = ["atome", "kits", "spaylater_spay", "boost", "grabpay"];
        break;

      case "kits":
        paymentRemoveList = ["prolindung"];
        break;

      default:
        paymentRemoveList = ["prolindung", "kits"];
        bankRemoveList = [];
    }

    this.paymentList = this.paymentList.filter(
      (obj) => !paymentRemoveList.includes(obj.alt)
    );

    this.bankList = this.bankList.filter(
      (obj) => !bankRemoveList.includes(obj.alt)
    );
  }

  isCarsomeGroup(): boolean {
    return ["carsome", "wapcar", "carlist", "carsomereferral"].includes(this.partnerCode);
  }

  isCustomFooterDB() {
    return this.partnerDataService?.partnerDetail?.enableCustomFooter || false;
  }

  getFooterClasses(): string {
    if (
      this.component === "ComparisonComponent" &&
      this.stepperIndex >= 1 &&
      this.stepperIndex != 3
    ) {
      return "comparison-mobile-view-footer";
    } else if (this.component === "PlansComponent") {
      return "plans-mobile-view-footer";
    } else if (this.component === "TopupRequestComponent") {
      return "topup-request-mobile-view-footer";
    } else {
      return null;
    }
  }

  // private getPartnerCode() {
  // 	this.partnerCode = this.partnerService.getPartnerCode();
  // 	!this.partnerCode ? (this.partnerCode = "ps") : null;
  // 	if (this.customFooterContact.includes(this.partnerCode)) {
  // 		this.isCustomFooterContact = true;
  // 	}
  // 	if (this.hideFooterList.includes(this.partnerCode)) {
  // 		this.hideFooter = true;
  // 	}
  // }
}
